import api from "./api";

const VendorCategoryService = {
 getAll: async (page = 1, limit = 20) => {
  const res = await api.get(`/vendorCategory/getAll?page=${page}&limit=${limit}`);
  return res.data;
},

  getById: async (id) => {
    const res = await api.get(`/vendorCategory/getById/${id}`);
    return res.data;
  },

  // Create vendor category
  create: async (data) => {
    const res = await api.post("/vendorCategory/save", data);
    return res.data;
  },

  // Update vendor category
  update: async (id, data) => {
    const res = await api.put(`/vendorCategory/update/${id}`, data);
    return res.data;
  },

  // Toggle Active / Inactive
  toggleStatus: async (id) => {
    const res = await api.put(`/vendorCategory/updateStatus/${id}`);
    return res.data;
  },

  // Get Active List Only
  getActive: async () => {
    const res = await api.get("/vendorCategory/getActive");
    return res.data;
  },

  // Delete vendor category
  delete: async (id) => {
    const res = await api.delete(`/vendorCategory/${id}`);
    return res.data;
  },
};

export default VendorCategoryService;
